import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function ContentBlock({ children, className, ...rest }) {
    return (
        <div
            data-component="ContentBlock"
            className={cx('sarsa-content-block', className)}
            {...rest}>
            {children}
        </div>
    )
}

ContentBlock.propTypes = {
    /** Contents */
    children: PropTypes.node,

    /** Additional class added to the outer container */
    className: PropTypes.string
};
